import { Component, OnInit } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { LogFinanceiraService } from './log-financeira.service';

@Component({
  selector: 'ngx-log-financeira',
  templateUrl: './log-financeira.component.html',
  styleUrls: ['./log-financeira.component.scss']
})
export class LogFinanceiraComponent implements OnInit {

  public formLogFinanceira = null;
  public isTed = false;
  public isBoleto = false;
  public isRecarga = false;
  public cnpjCpf = null;
  public id = null;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private service: LogFinanceiraService,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private encriptyService: EncriptyUtilService,

  ) {
    this.activatedRoute.queryParams.subscribe(register => {    
      
    });
  }

  ngOnInit() {

    this.formLogFinanceira = this.formBuilder.group({ 
      jsonChamado: [null],
      jsonRetorno: [null],
    });

  }
 

  previousPage() {

    this.location.back();

  }

  gotoVoltar() {

    this.location.back();

  }

}
